import styled from "styled-components";

export const MainProfileImgBox = styled.div<any>`
  overflow: hidden;
  width: ${(props) => (props.width ? `${props.width}px` : "60px")};
  height: ${(props) => (props.height ? `${props.height}px` : "60px")};
  /* margin-top: 10px; */
  border-radius: 50%;
`;
